"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'FormInput',
  props: {
    val: {
      type: [String, Number],
      default: ''
    },
    // 编辑模式 view edit
    mode: {
      type: String,
      default: 'edit'
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否显示限制（必须填了最大长度才显示）
    showWordLimit: {
      type: Boolean,
      default: true
    },
    // placeholder
    placeholder: {
      type: String,
      default: ''
    },
    /**
     * 提示
     */
    tipable: {
      type: Boolean,
      default: false
    },
    tipmin: {
      type: Number,
      default: 20
    }
  },
  data: function data() {
    return {
      inputVal: this.val
    };
  },
  computed: {
    isDisabled: function isDisabled() {
      return this.mode === 'view' || this.disabled;
    },
    placeholderTxt: function placeholderTxt() {
      var txt = this.placeholder || this.$t('common.pleaseInput');
      return this.isDisabled ? '' : txt;
    },
    isTooltipDisabled: function isTooltipDisabled() {
      var len = (this.inputVal + '').length;
      return this.mode === 'edit' || !this.tipable || this.tipmin > len;
    }
  },
  watch: {
    val: {
      deep: true,
      immediate: true,
      handler: function handler(newVal) {
        this.inputVal = newVal;
      }
    }
  },
  methods: {
    onInput: function onInput(val) {
      if (this.isDisabled) {
        return false;
      }
      this.$emit('update:val', val);
    }
  }
};